import React from 'react'

import PrimaryHeader from '../../../components/primary-header'
import Title from '../../../components/title'
import ChatCard from '../../../components/chat-card'
import SearchInput from '../../../components/search-input'

import * as S from './styles'

import IProps from './props'

const Chats = ({ states, handlers }: IProps) => (
  <S.Container>
    <PrimaryHeader>
      <Title>
        <span>Chat</span>
      </Title>
    </PrimaryHeader>
    <S.Content>
      <SearchInput
        placeholder="Buscar por um chat"
        value={states.search}
        onChange={handlers.handleChange}
        onSearch={handlers.handleSearch}
      />
      <S.ChatList>
        {states.resource.map((chat: any) => (
          <ChatCard
            key={chat.id}
            chat={chat}
            onClick={handlers.handleChatClick}
          />
        ))}
      </S.ChatList>
    </S.Content>
  </S.Container>
)

export default Chats
